module.exports = __webpack_public_path__ + "static/offer-2-ec5e487ecf84a640913af5dfbb41a1f1.png";